export const SET_PESSOAS_JURIDICA = "PESSOAS_JURIDICA/SET_PESSOAS_JURIDICA";
export const SET_PESSOA_JURIDICA = "PESSOAS_JURIDICA/SET_PESSOA_JURIDICA";
export const SET_PAGINATION = "PESSOAS_JURIDICA/SET_PAGINATION";
